export const imageQuality: Readonly<number> = 60
